import { render, staticRenderFns } from "./banner_logo_assante.vue?vue&type=template&id=8bfb5006&scoped=true&"
import script from "./banner_logo_assante.vue?vue&type=script&lang=js&"
export * from "./banner_logo_assante.vue?vue&type=script&lang=js&"
import style0 from "./banner_logo_assante.vue?vue&type=style&index=0&id=8bfb5006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfb5006",
  null
  
)

export default component.exports